import React, { useEffect} from "react";
import { Table  } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { getSalaryDeductionList, doSalaryDeductionDelete } from "../../../../redux/salarydeduction/salaryDeductionState";
import { NumberFormatter, handleTableChange } from "../../../../utils/index";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import PopupButton from "components/button/PopupButton";
import SalaryDeductionForm from "./SalaryDeductionForm";

const SalaryDeductionTable = ({ recordList, pagination, doSearch, filters, doDelete, ...props }) => {
  	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
		{
	        title: `Employee ID`,
	        dataIndex: 'emp_code',
	        key: 'emp_code',
	        width: '10%',
	        render:(emp_code) => <span>{emp_code}</span> 
	    },
	    {
	        title: `Employee Name`,
	        dataIndex: 'sdd_employee_name',
	        key: 'sdd_employee_name',
	        width: '15%',
	        sorter: true,
	        ...getColumnSearchProps('sdd_employee_name'),
	        render:(sdd_employee_name) => <span>{sdd_employee_name}</span>
	    },
	    {
	        title: `Date`,
	        dataIndex: 'sdd_start_date',
	        key: 'sdd_start_date',
	        width: '18%',
	        render:(sdd_start_date, record) => <span>{`${sdd_start_date} - ${record.sdd_end_date}`}</span>  
	    },
	    {
	        title: `Paycode`,
	        dataIndex: 'sdd_paycode_name',
	        key: 'sdd_paycode_name',
	        width: '15%',
	        sorter: true,	  
	        ...getColumnSearchProps('sdd_paycode_name'), 
	    },
	    {
	        title: <div className="text-right">Total Amount</div>,
	        dataIndex: 'sdd_total_amount',
	        key: 'sdd_total_amount',
	        width: '10%',
	        render: (sdd_total_amount) => <div className="text-right">{NumberFormatter(sdd_total_amount)}</div>
	    },
	    {
	        title: `Status`,
	        dataIndex: 'sdd_status_name',
	        key: 'sdd_status_name',
	        width: '10%',
	    },
	    {
	        title: `Payroll Type`,
	        dataIndex: 'sdd_type_name',
	        key: 'sdd_type_name',
	        width: '10%',
	    },
	    {
	        title: <PopupButton id="add_salary_deduction" title="Add Salary Deduction" label="Add" btnClass="btn-small" modalWidth={1200}>
						<SalaryDeductionForm recordId="0" mode="edit"/>
					</PopupButton>,
	        dataIndex: 'sdd_id',
	        key: 'sdd_id',
	        width: '12%',
	        render:(sdd_id) => <CrudOption baseRoute="/console/salary-deductions" recordId={sdd_id} deleteHandler={doDelete}/>
	    },
    ];
    
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"} {...props}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		
	      		<SearchFilter searchHandler={doSearch} filters={filters} pagination={pagination}/>
	      		
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.sdd_id}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}               	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.salaryDeduction.salaryDeductionList?.items,
  	pagination: state.salaryDeduction.salaryDeductionList?.pagination,
	filters: state.salaryDeduction.salaryDeductionList?.filters,
  	requesting: state.salaryDeduction.salaryDeductionList?.requesting,
  	error: state.salaryDeduction.salaryDeductionList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getSalaryDeductionList(filters)),
  	doDelete: (id) => dispatch(doSalaryDeductionDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryDeductionTable);